module.exports = __webpack_public_path__ + "img/icon_invate.2633334d.png";